module.exports = __webpack_public_path__ + "static/media/Scene 10 for portfolio.ba0d8a04.jpg";